import React from "react";
import { motion } from "framer-motion";
import { ChatDotsFill, GearFill } from "react-bootstrap-icons";
import { Badge } from "react-bootstrap";

const SystemSmsSettings = () => {
  const providers = [
    { name: "nexmo", status: "Connected" },
    { name: "2 Factor", status: "Connected" },
    { name: "Twilio", status: "Connected" },
  ];

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <motion.div
        className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          SMS Settings
        </motion.h5>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-primary btn-sm"
        >
          + Add Template
        </motion.button>
      </motion.div>

      {/* PROVIDERS */}
      <div className="row g-3">
        {providers.map((item, i) => (
          <div className="col-md-4" key={i}>
            <motion.div
              className="card shadow-sm border-0 h-100"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.02 }}
            >
              <div className="card-body d-flex align-items-center justify-content-between">
                {/* LEFT */}
                <div className="d-flex align-items-center gap-2">
                  <div className="bg-light p-2 rounded d-flex align-items-center justify-content-center">
                    <ChatDotsFill size={18} />
                  </div>

                  <span className="fw-medium text-capitalize">{item.name}</span>
                </div>

                {/* RIGHT */}
                <div className="d-flex align-items-center gap-2">
                  <Badge bg="success">{item.status}</Badge>

                  <motion.div whileHover={{ scale: 1.2 }}>
                    <GearFill className="text-muted" />
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default SystemSmsSettings;
